var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCardsCba128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2267_8943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.772 30.829H13.2277C9.12417 30.829 5.79761 34.1555 5.79761 38.2591V92.7464C5.79761 96.8499 9.12417 100.176 13.2277 100.176H114.772C118.876 100.176 122.202 96.8499 122.202 92.7464V38.2591C122.202 34.1555 118.876 30.829 114.772 30.829Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6438 39.5927L34.2751 48.2461L25.6438 56.8995L17.0124 48.2461L25.6438 39.5927Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9429 77.8861H56.57",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9429 87.793H36.7564",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2267_8943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCardsCba128);
export default __webpack_public_path__ + "static/media/pictogramBeaconCardsCBA128.a833b2ad5a8a84521f295482369291a0.svg";
export { ForwardRef as ReactComponent };